import {
  Box,
  IconButton,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CancelPauseModal } from "../../Modals/cancelPauseModal";
import { RefundCouponModal } from "../../Modals/refundCouponModal";
import { UpgradeDowngradeModal } from "../../Modals/upgradeDowngradeModal";
import { PaymentLogsModal } from "../../Modals/paymentLogsModal";

const SubscriptionHistoryList = () => {

  const navigate = useNavigate();

  const rows = [
    {
      id: 1,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic [Monthly]",
      date: "24 Jul 2025",
      paymentMethod: "Stripe",
      status: "Active",
      statusClass: "c_success"
    },
    {
      id: 2,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic [Monthly]",
      date: "24 Jul 2025",
      paymentMethod: "Stripe",
      status: "Trial",
      statusClass: "c_warning"
    },
    {
      id: 3,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic [Monthly]",
      date: "--",
      paymentMethod: "--",
      status: "Expired",
      statusClass: "c_danger"
    },
    {
      id: 4,
      userName: "Madelyn Dias",
      userEmail: "madelyndias@gmail.com",
      plan: "Basic [Monthly]",
      date: "--",
      paymentMethod: "--",
      status: "Canceled",
      statusClass: "c_dark"
    },
  ];

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [menuRowId, setMenuRowId] = React.useState<number | null>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>, rowId: number) => {
    setAnchorEl(event.currentTarget);
    setMenuRowId(rowId);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setMenuRowId(null);
  };

  const [openModal1, setOpenModal1] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(false);
  const [openModal3, setOpenModal3] = React.useState(false);
  const [openModal4, setOpenModal4] = React.useState(false);

  return (
    <>
      <TableContainer className="table_container">
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Users</TableCell>
              <TableCell>Plan</TableCell>
              <TableCell>Renewal Date</TableCell>
              <TableCell>Payment Method</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow hover key={row.id}>
                <TableCell>
                  <div className="user_block click_action" onClick={() => navigate("/manage-users/detail")}>
                    <figure>
                      <img src="/static/images/user_placeholder.png" alt="" />
                    </figure>
                    <p><b>{row.userName}</b> <span>{row.userEmail}</span></p>
                  </div>
                </TableCell>
                <TableCell>{row.plan}</TableCell>
                <TableCell>{row.date}</TableCell>
                <TableCell>{row.paymentMethod}</TableCell>
                <TableCell><span className={`status_btn ${row.statusClass}`}>{row.status}</span></TableCell>
                <TableCell>
                  <div className="table_actions v2">
                    <Box>
                      <IconButton
                        aria-controls={open && menuRowId === row.id ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open && menuRowId === row.id ? "true" : undefined}
                        onClick={(e) => handleClick(e, row.id)}
                      >
                        <MoreVertIcon />
                      </IconButton>
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open && menuRowId === row.id}
                        onClose={handleClose}
                        MenuListProps={{ "aria-labelledby": "basic-menu" }}
                        transformOrigin={{ horizontal: "right", vertical: "top" }}
                        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                      >
                        <MenuItem onClick={() => { setOpenModal1(true); handleClose() }}>Cancel / Pause Plan</MenuItem>
                        <MenuItem onClick={() => { setOpenModal2(true); handleClose() }}>Upgrade / Downgrade</MenuItem>
                        <MenuItem onClick={() => { setOpenModal3(true); handleClose() }}>View Payment Logs</MenuItem>
                        <MenuItem onClick={() => { setOpenModal4(true); handleClose() }}>Issue Refund / Coupon</MenuItem>
                      </Menu>
                    </Box>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <CancelPauseModal open={openModal1} onClose={() => setOpenModal1(false)} setOpen={setOpenModal1} />
      <UpgradeDowngradeModal open={openModal2} onClose={() => setOpenModal2(false)} setOpen={setOpenModal2} />
      <PaymentLogsModal open={openModal3} onClose={() => setOpenModal3(false)} setOpen={setOpenModal3} />
      <RefundCouponModal open={openModal4} onClose={() => setOpenModal4(false)} setOpen={setOpenModal4} />
    </>
  );
};

export default SubscriptionHistoryList;
